module.exports = function (e) {
  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  var t = {};
  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      configurable: !1,
      enumerable: !0,
      get: n
    });
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, r.p = "", r(r.s = 0);
}([function (e, r, t) {
  "use strict";

  r.__esModule = !0, r.default = function (e, r) {
    if (e && r) {
      var t = Array.isArray(r) ? r : r.split(","),
          n = e.name || "",
          o = e.type || "",
          u = o.replace(/\/.*$/, "");
      return t.some(function (e) {
        var r = e.trim();
        return "." === r.charAt(0) ? n.toLowerCase().endsWith(r.toLowerCase()) : r.endsWith("/*") ? u === r.replace(/\/.*$/, "") : o === r;
      });
    }

    return !0;
  };
}]);